module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index text-sm text-blueGray-800"
  }, [(_vm.show_create_course_modal) ? _c('new-course-modal', {
    on: {
      "createCourse": _vm.createCourse,
      "close": function($event) {
        _vm.show_create_course_modal = false
      },
      "courseCreated": function($event) {
        _vm.show_course_created_modal = true
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_join_roundtable_modal) ? _c('join-roundtable-modal', {
    on: {
      "joinRoundtable": _vm.joinRoundtable,
      "modalClosed": function($event) {
        _vm.show_join_roundtable_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getProfile.role === 'guest' && !_vm.getProfile.loading) ? _c('choose-role', {
    staticStyle: {
      "max-width": "700px",
      "margin-left": "auto",
      "margin-right": "auto",
      "margin-top": "100px"
    },
    on: {
      "role": _vm.chooseRole
    }
  }) : [(!_vm.getProfile.loading) ? _c('router-view', {
    attrs: {
      "name": "dashboard"
    }
  }) : _vm._e(), _vm._v(" "), _c('router-view', {
    key: _vm.$store.state.isReloadComponent
  })], _vm._v(" "), _c('div', {
    ref: "toastContainer",
    staticClass: "fixed z-50 top-1 right-2 w-96"
  }, [(_vm.toast_show == 'true') ? _c('pl-toast', {
    attrs: {
      "toastType": 'Info',
      "toastMessage": _vm.toastMessage
    },
    on: {
      "close": _vm.removeInfo
    }
  }) : _vm._e()], 1), _vm._v(" "), (
    _vm.isOpenToastDemo === true &&
    (_vm.$route.params.roundtableID ===
      'a1f7390a-de1a-44a9-a8cf-370782a147f8' ||
      _vm.$route.params.liveDiscussionID ===
      'cf323be5-f772-415f-b336-fbf194d6a203' ||
      _vm.$route.params.courseID === _vm.$store.state.course_sample_id)
  ) ? _c('div', {
    ref: "toastContainers",
    staticClass: "fixed bg-sky-400 hover:bg-sky-500 z-50 top-1 right-2. w-96"
  }, [_c('div', {
    staticClass: "flex text-white rounded-sm w-full"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.isOpenToastDemo = false
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times text-white"
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row nowrap middle-xs between-xs",
    class: {
      active: _vm.alert_show
    },
    attrs: {
      "id": "alert-message"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('br'), _vm._v("\n      " + _vm._s(_vm.alert_message) + "\n    ")]), _vm._v(" "), _c('pl-button', {
    staticStyle: {
      "color": "#fff",
      "margin": "0"
    },
    nativeOn: {
      "click": function($event) {
        _vm.alert_show = false
      }
    }
  }, [_vm._v("CLOSE")])], 1), _vm._v(" "), (_vm.show_upgrade_modal) ? _c('upgrade-modal', {
    attrs: {
      "text": _vm.text,
      "studentReport": _vm.studentReport
    },
    on: {
      "close": function($event) {
        _vm.show_upgrade_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_upgrade_success_modal) ? _c('upgrade-success-modal', {
    on: {
      "closeModal": function($event) {
        _vm.show_upgrade_success_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_block_upgrade_modal) ? _c('upgrade-block-modal', {
    attrs: {
      "adminUsersOfSchool": _vm.adminUsersOfSchool
    },
    on: {
      "closeModal": function($event) {
        _vm.show_block_upgrade_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_email_suffix_block_modal) ? _c('email-suffix-block-modal', {
    attrs: {
      "emailSuffixesOfSchool": _vm.emailSuffixesOfSchool
    },
    on: {
      "closeModal": function($event) {
        _vm.show_email_suffix_block_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_role_changed_modal) ? _c('role-changed-modal', {
    on: {
      "closeModal": function($event) {
        _vm.show_role_changed_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_removed_student_from_school_modal) ? _c('removed-student-from-school-modal', {
    attrs: {
      "deleteCourse": _vm.deleteCourse
    },
    on: {
      "closeModal": function($event) {
        _vm.show_removed_student_from_school_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_school_courses_modal) ? _c('school-courses-modal', {
    attrs: {
      "header": _vm.header,
      "school": _vm.upgraded_school,
      "showUpgrade": true
    },
    on: {
      "closeModal": function($event) {
        _vm.show_school_courses_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_connect_integration_account_modal) ? _c('integrations-connect-account-modal', {
    attrs: {
      "selectedIntegration": _vm.account_integration
    },
    on: {
      "close": function($event) {
        _vm.show_connect_integration_account_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_course_created_modal) ? _c('course-created-modal', {
    on: {
      "close": function($event) {
        _vm.show_course_created_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_membership_invalid_modal) ? _c('pl-dialog', {
    staticStyle: {
      "padding": "25px"
    },
    attrs: {
      "disableOutsideClick": true,
      "maxWidth": "700px"
    },
    on: {
      "close": _vm.closeInvalidMembershipModal
    }
  }, [_c('pl-button', {
    staticClass: "pl-icon",
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeInvalidMembershipModal.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center pl-title ma pl-secondary mv3"
  }, [_c('strong', {
    staticClass: "tc"
  }, [_vm._v("Membership expired")])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center items-center"
  }, [_c('p', {
    staticClass: "pl-subheading tc mv4 pl-secondary",
    staticStyle: {
      "font-size": "18px",
      "max-width": "600px"
    }
  }, [_vm._v("\n        It looks like your school's Parlay membership has expired. Please\n        contact "), _c('b', [_vm._v(" annalisa@parlayideas.com")]), _vm._v(" to learn more and update your\n        membership.\n      ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.show_welcome_modal) ? _c('Onboarding', {
    on: {
      "close": function($event) {
        _vm.show_welcome_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isModalTeacherOpenAfterSignUp) ? _c('ModalTeacherAfterSignUp', {
    on: {
      "close": function($event) {
        _vm.isModalTeacherOpenAfterSignUp = false
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left-0 px-1 py-3 w-11/12 flex items-center"
  }, [_c('img', {
    staticClass: "text-2xl px-3",
    attrs: {
      "src": require("../app/components/material/components/plToast/info.svg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-sm justify-center items-center"
  }, [_vm._v("Hey! This is just a demo!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', [_vm._v("WARNING!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-35393a06!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/index.vue
// module id = 2452
// module chunks = 61